enum PERMISSIONS {
  //PublicAccessPermissions
  PublicDataAccess = 1,

  //CashBoxes
  CashboxesRead = 20,
  CashboxesCreate = 21,
  CashboxesUpdate = 22,
  CashboxesDelete = 23,

  //Orders
  OrdersRead = 40,
  OrdersCreate = 41,
  OrdersUpdate = 42,
  OrdersDelete = 43,
  OrdersReadAll = 44,
  OrdersExport = 45,
  OrdersDeleteNotMine = 46,
  OrdersSetTemporary = 47,
  OrdersAllDepartment = 48,
  OrderListAttributeEdit = 49,
  OrdersEditIssueDate = 50,
  OrdersSaveTradeTermToOtherOrder = 51,
  OrdersSaleDateNewerThenIssueDate = 52,
  OrdersPayerManualEdit = 53,

  DocumentsRead = 60,
  DocumentsCreate = 61,
  DocumentsUpdate = 62,
  DocumentsDelete = 63,
  DocumentsReadAll = 64,
  DocumentsEditOldDocuments = 65,
  DocumentsEditLastCreatedDocuments = 66,
  DocumentsPurchaseNetPriceEditAfterOneDay = 68,
  DocumentReprint = 69,
  DocumentsModifyVATTable = 70,
  DocumentsAddCorrectionNote = 71,
  DocumentsAcceptToSendOnlyUsers = 72,
  DocumentsAcceptToSendAll = 73,
  DocumentsActionAfterSend = 74,
  DocumentsPrintAll = 75,
  DocumentsAllDepartment = 76,

  PaymentsRead = 80,
  PaymentsCreate = 81,
  PaymentsUpdate = 82,
  PaymentsDelete = 83,

  CommercialCostsRead = 90,
  CommercialCostsCreate = 91,
  CommercialCostsUpdate = 92,
  CommercialCostsDelete = 93,
  CommercialCostsActionAfterIsEditingLocked = 94,
  CommercialCostsApproveDocument = 95,

  BookingsRead = 100,
  BookingsCreate = 101,
  BookingsUpdate = 102,
  BookingsDelete = 103,
  BookingsReadAll = 104,
  BookingsSelecting = 105,
  BookingsSelectingNotComplete = 106,
  BookingsBlockedToInvoiced = 107,
  BookingsBlockedEditExchangePropertyGrandTotal = 108,
  BookingsBlockedEditExchangePropertyPurchaseNetPriceInCurrency = 109,
  BookingsUpdateCreationDate = 110,
  BookingsAddToChain = 111,
  BookingsChangeStatusOnCanceledBooking = 112,
  BookingUpdateFutureSaleDate = 113,
  BookingShowFormOfPayment = 114,
  BookingsChangeHasCostDocumentFromBookingList = 115,
  BookingsSplit = 116,
  BookingsChainedClone = 117,
  BookingsUnlockToInvoice = 118,

  ServiceTypeRead = 120,
  ServiceTypeCreate = 121,
  ServiceTypeUpdate = 122,
  ServiceTypeDelete = 123,

  ContractorsRead = 140,
  ContractorsCreate = 141,
  ContractorsUpdate = 142,
  ContractorsDelete = 143,
  ContractorShortNameEdit = 144,
  ContractorCustomerAreaIdEdit = 145,
  ChangeContractorNip = 146,

  CostDocumentsOtherRead = 150,
  CostDocumentsOtherCreate = 151,
  CostDocumentsOtherUpdate = 152,
  CostDocumentsOtherDelete = 153,
  CostDocumentsOtherActionsOnLocked = 154,
  CostDocumentsOtherApproveDocument = 155,

  CostDocumentsRead = 160,
  CostDocumentsCreate = 161,
  CostDocumentsUpdate = 162,
  CostDocumentsDelete = 163,
  CostDocumentsActionAfterIsEditingLocked = 164,

  BookKeepingRead = 180,
  BookKeepingCreate = 181,
  BookKeepingLockMonth = 184,
  BookKeepingUnlockMonth = 185,
  BookKeepingLockMonthAllDepartment = 186,

  CostDocumentBufferRead = 190,
  CostDocumentBufferAssign = 191,

  FinanceCashDocumentsRead = 200,
  FinanceCashDocumentsCreate = 201,
  FinanceCashDocumentsUpdate = 202,
  FinanceCashDocumentsDelete = 203,

  FinanceCashReportsRead = 220,
  FinanceCashReportsCreate = 221,
  FinanceCashReportsUpdate = 222,
  FinanceCashReportsDelete = 223,

  FinanceOverduePaymentsRead = 240,
  FinanceOverduePaymentsCreate = 241,
  FinanceOverduePaymentsUpdate = 242,
  FinanceOverduePaymentsDelete = 243,

  FinanceBankStatementsRead = 260,
  FinanceBankStatementsCreate = 261,
  FinanceBankStatementsUpdate = 262,
  FinanceBankStatementsDelete = 263,
  FinanceBankStatementsAllDepartment = 264,
  FinanceBankStatementsDocumentsAllDepartment = 265,

  FinanceCreditCardsStatementsRead = 280,
  FinanceCreditCardsStatementsCreate = 281,
  FinanceCreditCardsStatementsUpdate = 282,
  FinanceCreditCardsStatementsDelete = 283,

  B2B = 298,
  FiscalPrinterCommands = 299,

  AdministrationsRead = 300,
  AdministrationsOnlyCurrentOfficeManage = 305, //NOWE

  AdministrationBookingsFilesRead = 310,
  AdministrationBookingsFilesCreate = 311,
  AdministrationBookingsFilesUpdate = 312,
  AdministrationBookingsFilesDelete = 313,

  AdministrationSendersRead = 320,
  AdministrationSendersCreate = 321,
  AdministrationSendersUpdate = 322,
  AdministrationSendersDelete = 323,

  AdministrationContractorsRead = 330,
  AdministrationContractorsCreate = 331,
  AdministrationContractorsUpdate = 332,
  AdministrationContractorsDelete = 333,
  AdministrationContractorsSaveAutoInvoiceSetting = 334,
  AdministrationContractorsTemplate = 335,
  AdministrationContractorsDeleteAutoInvoiceSetting = 336,

  AdministrationServiceTypesServicesRead = 340,
  AdministrationServiceTypesServicesCreate = 341,
  AdministrationServiceTypesServicesUpdate = 342,
  AdministrationServiceTypesServicesDelete = 343,

  AdministrationOfficesRead = 350,
  AdministrationOfficesCreate = 351,
  AdministrationOfficesUpdate = 352,
  AdministrationOfficesDelete = 353,

  AdministrationUsersRead = 360,
  AdministrationUsersCreate = 361,
  AdministrationUsersUpdate = 362,
  AdministrationUsersDelete = 363,

  AdministrationCurrentUserRead = 370,
  // AdministrationCurrentUserCreate = 371, - użytkownik może o sobie co najwyżej czytać i aktualizować dane.
  AdministrationCurrentUserUpdate = 372,
  //AdministrationCurrentUserDelete = 373,
  AdministrationCurrentUserCanChangeOfficeProfile = 374,

  AdministrationPrintersRead = 380,
  AdministrationPrintersCreate = 381,
  AdministrationPrintersUpdate = 382,
  AdministrationPrintersDelete = 383,
  AdministrationPrintersResendCommand = 384,
  AdministrationPrintersDailyReport = 385,
  AdministrationPrintersRestartFiscalPrinterService = 386,
  AdministrationPrintersSetFiscalPrinterDbSettings = 387,
  AdministrationPrintersAllDepartment = 388,
  AdministrationPrintersCanResendAllCommand = 389,

  AdministrationRolesRead = 390,
  AdministrationRolesCreate = 391,
  AdministrationRolesUpdate = 392,
  AdministrationRolesDelete = 393,

  AdministrationsEventLogRead = 400,

  AdministrationsAdvancedMethods = 410,

  AdministrationsScheduleRead = 420,
  AdministrationsScheduleCreate = 421,
  AdministrationsScheduleUpdate = 422,
  AdministrationsScheduleDelete = 423,
  AdministrationsScheduleRestart = 424,
  AdministrationsScheduleEnableSet = 425,

  AdministrationExportConfigurationRead = 430,
  AdministrationExportConfigurationCreate = 431,
  AdministrationExportConfigurationUpdate = 432,
  AdministrationExportConfigurationDelete = 433,

  AdministrationsClientZoneRead = 440,
  AdministrationsClientZoneCreate = 441,
  AdministrationsClientZoneUpdate = 442,
  AdministrationsClientZoneDelete = 443,

  AdministrationBankAccountRead = 450,
  AdministrationBankAccountCreate = 451,
  AdministrationBankAccountUpdate = 452,
  AdministrationBankAccountDelete = 453,
  AdministrationBankAccountOfficeProfile = 454,
  AdministrationBankAccountContractor = 455,

  AdministrationsJwtSettingsRead = 460,
  AdministrationsJwtSettingsCreate = 461,
  AdministrationsJwtSettingsUpdate = 462,
  AdministrationsJwtSettingsDelete = 463,

  AdministrationsProjectRead = 470,
  AdministrationsProjectCreate = 471,
  AdministrationsProjectUpdate = 472,
  AdministrationsProjectDelete = 473,

  AdministrationAttributeRead = 480,
  AdministrationAttributeCreate = 481,
  AdministrationAttributeUpdate = 482,
  AdministrationAttributeDelete = 483,

  AdministrationAttributeMapperRead = 485,
  AdministrationAttributeMapperCreate = 486,
  AdministrationAttributeMapperUpdate = 487,
  AdministrationAttributeMapperDelete = 488,

  AdministrationMailBoxRead = 490,
  AdministrationMailBoxCreate = 491,
  AdministrationMailBoxUpdate = 492,
  AdministrationMailBoxDelete = 493,

  ReportsRead = 500,
  ReportsReadAll = 501,
  ReportsDelete = 502,
  ReportsCreateAll = 504,

  ReportsBSPRead = 506,
  ReportsBSPCreate = 507,
  ReportsBSPParseFile = 508,

  ReportsSalesDocumentServiceDistributionCreate = 510,
  ReportsSaleReportCreate = 511,
  ReportsServiceTypeSalesCreate = 512,
  ReportsSalesDocumentsListCreate = 513,
  ReportsCashierSaleCreate = 514,
  ReportsSalesServicesCreate = 515,
  ReportsAdvanceInvoiceOutstandingStandardCreate = 516,
  ReportsCashierTraderProfitCreate = 517,
  ReportsBankAccountSalesDocumentsCreate = 518,
  ReportsSalesServicesCostCreate = 519,
  ReportsReceiptDocumentsCreate = 520,
  ReportsExportDocumentsCreate = 522,
  ReportsBookingsSoldCreate = 523,
  ReportsSalesServicesFromDocumentCreate = 524,
  ReportsBookingsSoldHotelCreate = 525,

  //Kontrahent
  ReportsContractorsListCreate = 530,
  ReportsContractorsTurnoverCreate = 531,
  ReportsContractorPaymentsHistoryCreate = 532,
  ReportsContractorsDiscountCreate = 533,
  ReportsInvoiceMailNotificationStatusCreate = 534,
  ReportsSalesReservationPrismCreate = 535,

  //Obroty
  ReportsMonthlyTurnoverCreate = 540,
  ReportsMBankFactoringCreate = 541,
  ReportsBNPParibasFactoringCreate = 542,

  //Płatności
  ReportsPaymentsTransferUnpairedStandardCreate = 550,
  ReportsOutstandingAdvancesCreate = 551,
  ReportsArrearsCreate = 552,
  ReportsOutstandingPaymentsCreate = 553,
  ReportsListOfSalesDocumentsCreate = 554,
  ReportsVindicationSentEmailsCreate = 555,

  //Bilety
  ReportsAirTicketsSoldCreate = 560,
  ReportsBSPTicketsCreate = 561,
  ReportsContractorAirTicketsSalesCreate = 562,
  ReportsContractorAirlinesTurnoverCreate = 563,
  ReportsContractorPassengersTicketsCreate = 564,
  ReportsTicketsVerificationCreate = 565,
  ReportsUninvoicedTicketsCreate = 566,
  ReportsUninvoicedBookingsCreate = 567,

  //Pegaz
  // ReportsCSVReport1Create = 570,
  ReportsBalancesSummaryCreate = 571,
  ReportsTransfersCreate = 572,

  //Moje
  ReportsCashierPaymentsDueCreate = 580,
  ReportsCashierListServicesSoldCreate = 581,
  ReportsProfitCreate = 582,

  //Turystyka
  ReportsTourismServicesCreate = 590,
  ReportsTourismGroupedServicesCreate = 591,

  //Dokumenty Kosztowe
  ReportsCostDocumentsNotPairedInvoicesCreate = 600,
  ReportsCostDocumentsCostDifferencesCreate = 601,
  ReportsCostDocumentsPurchasePriceDifferenceCreate = 602,
  ReportsCostDocumentsNotSettledSaleDocumentItemCreate = 603,
  ReportsCostDocumentItemNotSettledCreate = 604,
  ReportsCostDocumentListCreate = 605,
  ReportsPairedSaleDocumentWithCostDocumentCreate = 606,

  //Zszywanie rezerwacji
  GroupBookingItemRead = 610,
  GroupBookingItemCreate = 611,
  GroupBookingItemUpdate = 612,
  GroupBookingItemDelete = 613,
  GroupBookingItemDeleteAll = 614,
  GroupBookingItemUpdateAll = 615,

  AdministrationMailBoxConfigurationRead = 620,
  AdministrationMailBoxConfigurationCreate = 621,
  AdministrationMailBoxConfigurationUpdate = 622,
  AdministrationMailBoxConfigurationDelete = 623,

  AdministrationWorkFlowRead = 640,
  AdministrationWorkFlowCreate = 641,
  AdministrationWorkFlowUpdate = 642,
  AdministrationWorkFlowDelete = 643,

  OrderUserCanChangeIndividualContractorTIN = 650,

  //BookingItemService w Administracji
  BookingItemServiceRead = 660,
  BookingItemServiceCreate = 661,
  BookingItemServiceUpdate = 662,
  BookingItemServiceDelete = 663,
  BookingItemServiceModify = 664,
  BookingItemServiceExport = 665,

  IntegrationSettingServiceRead = 670,
  IntegrationSettingServiceCreate = 671,
  IntegrationSettingServiceUpdate = 672,
  IntegrationSettingServiceDelete = 673,

  ExchangeRateProviderRead = 680,
  ExchangeRateProviderCreate = 681,
  ExchangeRateProviderUpdate = 682,
  ExchangeRateProviderDelete = 683,

  AdministrationMailHistoryRead = 690,
  AdministrationMailHistoryCreate = 691,
  AdministrationMailHistoryUpdate = 692,
  AdministrationMailHistoryDelete = 693,

  DatabasePerformanceRead = 700,
  DatabasePerformanceCreate = 701,
  DatabasePerformanceUpdate = 702,
  DatabasePerformanceDelete = 703,

  DeveloperRead = 710,
  DeveloperCreate = 711,
  DeveloperUpdate = 712,
  DeveloperDelete = 713,

  BookingsAllDepartment = 720,
  BookingsDetails = 721,

  AdministrationXMLConfigurationRead = 730,
  AdministrationXMLConfigurationCreate = 731,
  AdministrationXMLConfigurationUpdate = 732,
  AdministrationXMLConfigurationDelete = 733,

  AdministrationPrintersNotificationRead = 740,
  AdministrationPrintersNotificationCreate = 741,
  AdministrationPrintersNotificationUpdate = 742,
  AdministrationPrintersNotificationDelete = 743,

  MailContentConfigurationRead = 750,
  MailContentConfigurationCreate = 751,
  MailContentConfigurationUpdate = 752,
  MailContentConfigurationDelete = 753,

  VindicationSendEmail = 760,
  VindicationRead = 761,
  VindicationCreate = 762,
  VindicationUpdate = 763,
  VindicationDelete = 764,

  ReturnToReceiptReportRead = 770,
  ProtocolReturnToReceiptDelete = 771,

  AdministrationServicePackageRead = 780,
  AdministrationServicePackageCreate = 781,
  AdministrationServicePackageUpdate = 782,
  AdministrationServicePackageDelete = 783,

  AdministrationAirLineRead = 800,
  AdministrationAirLineCreate = 801,
  AdministrationAirLineUpdate = 802,
  AdministrationAirLineDelete = 803,

  ReportsSystemServiceTypeCreate = 810,
  ReportsNotificationsCreate = 811,

  BookingReportsRead = 820,
  BookingReportsToggleStatus = 821,
  BookingReportsPair = 822,

  ContractRead = 830,
  ContractCreate = 831,
  ContractUpdate = 832,
  ContractDelete = 833,

  CostHintRead = 840,
  CostHintCreate = 841,
  CostHintUpdate = 842,
  CostHintDelete = 843,
}

export { PERMISSIONS };
export default PERMISSIONS;
